import { createFileRoute } from "@tanstack/react-router";
import { requireAdminRoute } from "@/lib/require-admin-route";

export const Route = createFileRoute("/_app/settings/markets")({
  beforeLoad: requireAdminRoute,
});
